import { render, staticRenderFns } from "./sales-summary.vue?vue&type=template&id=054ddb46"
import script from "./sales-summary.vue?vue&type=script&lang=js"
export * from "./sales-summary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports